import {useMemo} from 'react'
import {useReviewSummaries} from '../../../../../stores/layout-selectors'
import {dedupeReviewSummaries} from './dedupe-review-summaries'

export function useReviews() {
  const reviewSummaries = useReviewSummaries()

  // `reviewSummaries` is a stable reference from the layout store, so this only recomputes when the
  // underlying review data actually changes rather than on every render.
  return useMemo(() => dedupeReviewSummaries(reviewSummaries), [reviewSummaries])
}
